

export default function searchControls() {

    $(function(){
        const $body = $('body');

        $('.toggle-search').on('click', function(e){
            e.preventDefault();
            $body.toggleClass('search-open');
            if ($body.hasClass('search-open')) {
                setTimeout(()=>($('.header-search').find('input[type=search]').focus()), 450);
            }
        });
    });

}